import VueSlick from "vue-slick";
import './components/index.js';
import { VueMaskDirective } from 'v-mask';

Vue.component('vue-slider', VueSlick);
Vue.directive('mask', VueMaskDirective);

const app = new Vue({
  el: '#app'
});